import { colors } from '@karnott/colors';
import CircledIcon from '../utils/circledIcon';

export const DataManyIcon = ({ color = '#000', size = 30, backgroundColor = colors('grey'), circled = false }) => (
  <CircledIcon {...{ backgroundColor, circled, size }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={circled ? '60%' : '100%'}
      height={circled ? '60%' : '100%'}
      viewBox="0 0 32.001 25.5"
    >
      <g transform="translate(1 1)">
        <path
          d="M1436.968,196.221c0,1.365-2.984,2.471-6.664,2.471s-6.664-1.106-6.664-2.471,2.984-2.471,6.664-2.471S1436.968,194.856,1436.968,196.221Z"
          transform="translate(-1406.967 -193.75)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M1436.968,199.848c0,1.365-2.984,2.471-6.664,2.471"
          transform="translate(-1406.967 -193.75)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M1436.968,203.475c0,1.365-2.984,2.471-6.664,2.471"
          transform="translate(-1406.967 -193.75)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M1436.968,207.1c0,1.365-2.984,2.471-6.664,2.471"
          transform="translate(-1406.967 -193.75)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <line
          y2="4.205"
          transform="translate(16.673 2.471)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <line
          y2="10.882"
          transform="translate(30.001 2.471)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M1420.3,199.123c0,1.365-2.984,2.471-6.664,2.471s-6.664-1.106-6.664-2.471,2.984-2.471,6.664-2.471S1420.3,197.758,1420.3,199.123Z"
          transform="translate(-1406.967 -193.75)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M1416.977,204.888a16.082,16.082,0,0,1-3.345.333c-3.68,0-6.664-1.106-6.664-2.471"
          transform="translate(-1406.967 -193.75)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M1416.977,208.516a16.083,16.083,0,0,1-3.345.333c-3.681,0-6.664-1.106-6.664-2.471"
          transform="translate(-1406.967 -193.75)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M1416.977,212.143a16.083,16.083,0,0,1-3.345.333c-3.68,0-6.664-1.106-6.664-2.471"
          transform="translate(-1406.967 -193.75)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <line
          y2="10.882"
          transform="translate(0.001 5.373)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <line
          y2="2.525"
          transform="translate(13.328 5.373)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M1429.5,202.286c-.31-.014-.555-.029-.81-.054"
          transform="translate(-1406.967 -193.75)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M1433.671,201.971a16.081,16.081,0,0,1-3.345.333q-.419,0-.822-.018"
          transform="translate(-1406.967 -193.75)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M1430.3,203.9c0,1.365-2.984,2.471-6.664,2.471s-6.664-1.106-6.664-2.471,2.984-2.471,6.664-2.471S1430.3,202.532,1430.3,203.9Z"
          transform="translate(-1406.967 -193.75)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M1430.3,207.524c0,1.365-2.984,2.471-6.664,2.471s-6.664-1.106-6.664-2.471"
          transform="translate(-1406.967 -193.75)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M1430.3,211.152c0,1.365-2.984,2.471-6.664,2.471s-6.664-1.106-6.664-2.471"
          transform="translate(-1406.967 -193.75)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M1430.3,214.779c0,1.365-2.984,2.471-6.664,2.471s-6.664-1.106-6.664-2.471"
          transform="translate(-1406.967 -193.75)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <line
          y2="10.882"
          transform="translate(10.009 10.147)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <line
          y2="10.882"
          transform="translate(23.337 10.147)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  </CircledIcon>
);
